import React, { useState, useEffect, useContext, useRef } from "react";
import { DataGrid, gridClasses } from "@mui/x-data-grid";
import { useNavigate } from "react-router-dom";
import {
  Grid,
  Checkbox,
  Button,
  TextField,
  Typography,
  IconButton,
  FormHelperText,
  makeStyles,
} from "@material-ui/core";

import Box from "@mui/material/Box";
import CloseIcon from "@mui/icons-material/Close";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";
import FormControlLabel from "@mui/material/FormControlLabel";

import { useQuery, useManualQuery, useMutation, ClientContext } from "graphql-hooks";


import { GET_ALL_GROUP_USERS_QUERY } from "../../graphQL/group_qry";


const useStyles = makeStyles((theme) => ({
  outlinedButtonStyle: {
    borderRadius: 4,
    width: "100px",
    padding: 0,
    color: "#0D47A1",
    height: "34px",
    textTransform: "none",
  },
  buttonStyle: {
    borderRadius: 4,
    width: "100px",
    padding: 0,
    color: "#fff",
    height: "34px",
    backgroundColor: "#0D47A1",
    textTransform: "none",
    "&:active": {
      backgroundColor: "#0D47A1",
    },
    "&:hover": {
      backgroundColor: "#1E88E5",
    },
  },
  textFieldStyle: {
    marginBottom: 5,
    marginTop: 30,
    "& .MuiInputLabel-outlined": {
      fontSize: 16,
    },
    "& .MuiOutlinedInput-root": {
      borderRadius: 10,
      fontSize: 16,
    },
  },
  errorStyle: {
    marginTop: 0,
    fontSize: 14,
    fontFamily: "Arial",
  },
}));


export default function GroupStaffListDialog({
  closeDialog,
  groupUuid,
  groupName
}) {
  const classes = useStyles();
  const [open, setOpen] = useState(true);

  const [staffList, setStaffList] = useState([]);

  
  const navigate = useNavigate();
  
 
  
  
  const [fetchGroupStaffList] = useManualQuery(GET_ALL_GROUP_USERS_QUERY, {
    fetchPolicy: "network-only",
  });
  
  const handleClose = () => {
    setOpen(false);
    closeDialog && closeDialog();
  };

  useEffect(() => {
    (async () => getStaffList())();
  }, []);
  
 
  
  const getStaffList = async () => {
    const {
      loading: loadingStaffList,
      error: errorStaffList,
      data: dataStaffList,
    } = await fetchGroupStaffList({
      variables: {
        groupUuid: groupUuid,
      },
    });

    if (!loadingStaffList && dataStaffList && dataStaffList.getAllGroupUsers) {
      
      setStaffList(dataStaffList.getAllGroupUsers);

    }
      
  };
  
  const columns = [
    {
      field: "fullName",
      headerName: "Full Name",
      headerClassName: "super-app-theme--header",
      minWidth: 170,
      flex: 1,
      sortable: false,
      disableColumnMenu: true,
    },

    {
      field: "email",
      headerClassName: "super-app-theme--header",
      headerName: "Email",
      minWidth: 200,
      flex: 1,
      sortable: false,
      align: "center",
      headerAlign: "center",
      disableColumnMenu: true,
    },

    {
      field: "status",
      headerClassName: "super-app-theme--header",
      headerName: "Status",
      minWidth: 100,
      flex: 2,
      sortable: false,
      align: "center",
      headerAlign: "center",
      disableColumnMenu: true,
    },

    
  ];

  function CustomNoRowsOverlay() {
  return (    
      
      <Box sx={{ mt: 2 }}>There is no staff for this group</Box>
    
  );
}
  
const rows = staffList.map((staff, index) => ({ 
    index,
    id: staff.tenantUserId.tenantUserId,
    fullName: staff.tenantUserId.userId.firstName + " " + staff.tenantUserId.userId.lastName,
    email: staff.tenantUserId.userId.email,
    status: staff.tenantUserId.userId.isActive ? "Active" : "Inactive",
    
  }));
  
  
    
  return (
    <div>
      <Dialog disablePortal
        open={open}
        onClose={handleClose}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
        sx={{
          "& .MuiDialog-container": {
            "& .MuiPaper-root": {
              width: "100%",
              maxWidth: "600px",
              height: "600px"
            },
          },
        }}
      >
        <DialogTitle
          sx={{ m: 0, p: 2 }}
          id="alert-dialog-title"
          style={{ display: "flex", justifyContent: "space-between" }}
        >
          <Box mt={1} ml={1}>
            Staff List for Group: {groupName}
          </Box>
          {closeDialog ? (
            <IconButton
              aria-label="close"
              onClick={handleClose}
              sx={{
                position: "absolute",
                right: 8,
                top: 8,
                align: "right",
                color: (theme) => theme.palette.grey[500],
              }}
            >
              <CloseIcon />
            </IconButton>
          ) : null}
        </DialogTitle>
        <DialogContent>
           
            <DataGrid
              className={classes.dataGridStyle}
              columns={columns}
              rows={rows}
              showCellRightBorder={true}
              hideFooter={true}
              autoWidth={true}
              slots={{
                noRowsOverlay: CustomNoRowsOverlay,
              }}
              getRowId={row => row.id}
              getRowClassName={params => {
                if (params.row.index % 2 === 0) return "even";
                else return "odd";
              }}
              autoHeight={true}
              experimentalFeatures={{ newEditingApi: true }}
            />
            
           
        </DialogContent>
        <DialogActions style={{ justifyContent: "center" }}>
          <Box mb={2}>
            <Button
                variant="contained"
                color="primary"
                className={classes.buttonStyle}
                style={{ marginRight: 2 }}
                onClick={handleClose}
            >
                Done
            </Button>
            
          </Box>
        </DialogActions>
      </Dialog>
    </div>
  );
}
